export default __webpack_public_path__ + "locales/pt/SingleSignOn.json?hash=a4ead2d28f1c668a6fcc1ab8b76a20e1";